// removed by extract-text-webpack-plugin
module.exports = {"standAloneButtonsContainer":"StandAloneButtons__standAloneButtonsContainer___34Irf","standAloneButtonContainer":"StandAloneButtons__standAloneButtonContainer___aRrDi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StandAloneButtons/StandAloneButtons.scss
// module id = 197
// module chunks = 0